
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { defaultDomicilio, DomicilioProps } from "./DomicilioInterface";
import { SexoProps } from "../catalogos/SexoInterface";
import { EstadoProps } from "../catalogos/EstadoInterface";
import { TipoPersonaProps } from "../catalogos/TipoPersonaInterface";

// Definición de defaults

export const defaultPersonaBusqueda : PersonaBusquedaProps = { idPersona: 0, nombreCompleto: '', curp: '', idTipoPersona: 0, };

export const defaultAgregarPersona: AgregarPersonaResponse = {
    ...defaultHttpResponse,
    idPersona:          0,
    idTipoPersona:      0,
    curp:               '',
    nombreCompleto:     '',
}

export const defaultAgregarDomicilioPersona: AgregarDomicilioPersonaResponse = {
    ...defaultHttpResponse,
    domicilio:      defaultDomicilio,
}

// Creación de interfaces

export interface PersonaProps {
    idPersona:              number;
    curp?:                  string;
    nombres?:               string;
    apellido1?:             string;
    apellido2?:             string;
    nombreCompleto?:        string;
    rfc?:                   string;
    razonSocial?:           string;
    idSexo?:                number;
    sexo?:                  SexoProps;
    idTipoPersona?:         number;
    tipoPersona?:           TipoPersonaProps;
    idEntidadNacimiento?:   number;
    entidadNacimiento?:     EstadoProps;
}

export interface PersonaBusquedaProps {
    idPersona:          number;
    curp:               string;
    nombreCompleto:     string;
    idTipoPersona:      number;
}

export interface BuscarPersonaParams {
    nombre?:             string;
    apellido1?:          string;
    apellido2?:          string;
    curp?:               string;
    rfc?:                string;
    idTipoPersona?:      number;
}

export interface AgregarPersonaParams {  
    curp?:                  string;
    nombres?:               string;
    apellido1?:             string;
    apellido2?:             string;
    rfc?:                   string;
    razonSocial?:           string;
    fechaNacimiento?:       string;
    idSexo?:                number;
    idTipoPersona?:         number;
    idEntidadNacimiento?:   number;
}

export interface AgregarPersonaResponse extends HttpResponse { 
    idPersona:              number;
    idTipoPersona:          number;
    curp:                   string;
    nombreCompleto:         string;
}

export interface AgregarDomicilioPersonaParams {
    idPersona:          number;
    descripcion:        string;
    numero:             string;
    referencia:         string;
    idAsentamiento:     number;
    idTipoDomicilio:    number;
}

export interface AgregarDomicilioPersonaResponse extends HttpResponse { 
    domicilio:      DomicilioProps;    
}